<template>
  <div>
    <div class="title-area text-left">
      <h4>Integre com suas redes favoritas.</h4>
      <p>Selecione quais plataformas você mantém sempre com bons conteúdos.</p>
    </div>
    <div class="input-area pt-3">
      <Integrations
        :siteId="this.siteId"
        @hasConnection="confirmConnection($event)"
      ></Integrations>
    </div>
    <div class="row">
      <div class="col-12" v-if="showError">
        <p class="error-message">
          <strong
            ><small
              >Integre uma rede social para continuar ou pule esta etapa.</small
            ></strong
          >
        </p>
      </div>
      <div class="row fixed-bottom justify-content-center">
        <div class="col-auto" v-if="countConections < 1">
          <button class="btn btn-large btn-skip" @click="skipStep">
            Pular
          </button>
        </div>
        <div class="col-auto text-center" v-else>
          <button
            class="btn btn-primario btn-extra-large"
            @click="verifyToProceed()"
          >
            Continuar
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Integrations from "@/components/Integrations";
export default {
  name: "StepWizardIntegrations",
  data() {
    return {
      countConections: 0,
      showError: false,
    };
  },
  components: {
    Integrations,
  },
  computed: {
    siteId() {
      return this.$session.get("siteId");
    },
  },
  methods: {
    confirmConnection(count) {
      this.countConections = count;
      this.showError = false;
    },
    skipStep() {
      this.$emit("nextStep", "jump");
    },
    skipStepContinue() {
      this.$emit("nextStep", "continue");
    },
    verifyToProceed() {
      this.showError = false;
      if (this.countConections > 0) {
        this.skipStepContinue();
      } else {
        this.showError = true;
      }
    },
  },
  mounted() {
    this.$emit("updateStep");
    this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [false]);
  },
  destroyed() {
    // this.$store.dispatch("WIZARD_SAVE_MEDIAS");
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardIntegrations.vue